import { getDownloadURL, ref } from "firebase/storage";
import React, { useEffect, useRef, useState } from "react";
import { uploadImageToStorage } from "../../firebase/fireFuncs";
import { storage } from "../../firebase/fireInit";
import { showImagePreviewWithFileReader } from "../helperfuncs";

const PickImageImage = ({
  imgUrl,
  size = "100%",
  imageWidth,
  storagePath,
  changeable = true,
  onImageChanged,
  maxHeight = "170px",
  standardImage,
}) => {
  const image = useRef(null);
  const inputFile = useRef(null);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    if (imgUrl != "" && imgUrl != null) {
      getDownloadURL(ref(storage, imgUrl)).then((url) => {
        image.current.setAttribute("src", url);
      });
    }
  }, [image, imgUrl]);

  const onFileChange = (e) => {
    let file = e.target.files[0];
    setSelectedImage(file);
    showImagePreviewWithFileReader(file, image.current);
  };

  useEffect(() => {
    if (selectedImage != null) {
      uploadImageToStorage(storagePath, selectedImage, (path) => {
        onImageChanged(path);
      });
    }
  }, [selectedImage]);

  return (
    <div
      className="divRow"
      style={{ height: size, maxWidth: imageWidth ?? null, cursor: "pointer" }}
    >
      <form className="imageForm">
        <input
          type="file"
          ref={inputFile}
          onChange={onFileChange}
          style={{ display: "none" }}
          accept="image/*"
        />
      </form>
      <img
        style={{
          objectFit: "contain",
          height: "100%",
          width: "100%",
          maxHeight: maxHeight,
        }}
        ref={image}
        id="target"
        onClick={() => {
          inputFile.current.click();
        }}
        src={standardImage ?? "/icons/icon_question.png"}
      />
    </div>
  );
};

export default PickImageImage;
